// Libs
import React from 'react';
import { useComponentsPool } from '../../ComponentsPool';
import store from '../../store';

// Context
const dispatch = store.dispatch;

const Groups = () => {
    const { Component } = useComponentsPool();
    return <Component componentName={'GroupsIndex'} />;
};

export default Groups;
